import data from './lists/WAW2_Before_words_022123.json';

interface WordChoiceV2 {
  word: string;
  correction: string;
}
export default function words(): Array<WordChoiceV2> {
  return data;
}
